// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetApiV1Assets (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1Collateral (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1BorrowLendMarkets (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1BorrowLendMarketsHistory (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1Markets (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1Market (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1Ticker (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1Tickers (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1Depth (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1Klines (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1MarkPrices (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1OpenInterest (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1FundingRates (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1Status (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1Ping (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1Time (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1Wallets (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1Trades (params?: {}): Promise<implicitReturnType>;
    publicGetApiV1TradesHistory (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1Account (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AccountLimitsBorrow (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AccountLimitsOrder (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AccountLimitsWithdrawal (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1BorrowLendPositions (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1Capital (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1CapitalCollateral (params?: {}): Promise<implicitReturnType>;
    privateGetWapiV1CapitalDeposits (params?: {}): Promise<implicitReturnType>;
    privateGetWapiV1CapitalDepositAddress (params?: {}): Promise<implicitReturnType>;
    privateGetWapiV1CapitalWithdrawals (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1Position (params?: {}): Promise<implicitReturnType>;
    privateGetWapiV1HistoryBorrowLend (params?: {}): Promise<implicitReturnType>;
    privateGetWapiV1HistoryInterest (params?: {}): Promise<implicitReturnType>;
    privateGetWapiV1HistoryBorrowLendPositions (params?: {}): Promise<implicitReturnType>;
    privateGetWapiV1HistoryDust (params?: {}): Promise<implicitReturnType>;
    privateGetWapiV1HistoryFills (params?: {}): Promise<implicitReturnType>;
    privateGetWapiV1HistoryFunding (params?: {}): Promise<implicitReturnType>;
    privateGetWapiV1HistoryOrders (params?: {}): Promise<implicitReturnType>;
    privateGetWapiV1HistoryRfq (params?: {}): Promise<implicitReturnType>;
    privateGetWapiV1HistoryQuote (params?: {}): Promise<implicitReturnType>;
    privateGetWapiV1HistorySettlement (params?: {}): Promise<implicitReturnType>;
    privateGetWapiV1HistoryStrategies (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1Order (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1Orders (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1AccountConvertDust (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1BorrowLend (params?: {}): Promise<implicitReturnType>;
    privatePostWapiV1CapitalWithdrawals (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1Order (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1Orders (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1Rfq (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1RfqAccept (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1RfqRefresh (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1RfqCancel (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1RfqQuote (params?: {}): Promise<implicitReturnType>;
    privateDeleteApiV1Order (params?: {}): Promise<implicitReturnType>;
    privateDeleteApiV1Orders (params?: {}): Promise<implicitReturnType>;
    privatePatchApiV1Account (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
